export default __webpack_public_path__ + "static/media/the-ambush-featured-image.51471679.png";